<template>
  <div class="card">
    <div
      class="main-card-body"
    >
      <div class="main-body__css">
        <div class="electronic-documents card card-md-12">
          <el-card>
            <div slot="header">
              <p class="card-header__title">Văn bản điện tử:</p>
            </div>
            <div class="card-body-md-12">
              <b-row>
                <b-col lg="3" md="6">
                  <div class="card-body__block document-in__block" @click="goToPage('total')">
                    <p class="count mb-4">
                      {{
                        electronicDocument.totalDocument >= 10 ?
                          electronicDocument.totalDocument :
                          "0" + electronicDocument.totalDocument
                      }}
                    </p>
                    <p class="title">
                      Tất cả <br/>văn bản
                    </p>
                    <div class="icon">
                      <i class="isax-bold-document-forward"></i>
                    </div>
                  </div>
                </b-col>
                <b-col lg="3" md="6">
                  <div class="card-body__block document-unread__block" @click="goToPage('ElectronicDocument')">
                    <p class="count mb-4">
                      {{
                        electronicDocument.incomingDocument >= 10 ?
                          electronicDocument.incomingDocument :
                          "0" + electronicDocument.incomingDocument
                      }}
                    </p>
                    <p class="title">
                      Văn bản <br/>đến
                    </p>
                    <div class="icon">
                      <i class="isax-bold-document-forward"></i>
                    </div>
                  </div>
                </b-col>
                <b-col lg="3" md="6">
                  <div class="card-body__block document-sign__block" @click="goToPage('unreadDocument')">
                    <p class="count mb-4">
                      {{
                        electronicDocument.unreadDocument >= 10 ?
                          electronicDocument.unreadDocument :
                          "0" + electronicDocument.unreadDocument
                      }}
                    </p>
                    <p class="title">
                      Văn bản <br/>chưa đọc
                    </p>
                    <div class="icon">
                      <i class="isax-bold-document-text"></i>
                    </div>
                  </div>
                </b-col>
                <b-col lg="3" md="6">
                  <div class="card-body__block document-promulgate__block" @click="goToPage('document-sign')">
                    <p class="count mb-4">
                      {{
                        electronicDocument.documentToBeSigned >= 10 ?
                          electronicDocument.documentToBeSigned :
                          "0" + electronicDocument.documentToBeSigned
                      }}
                    </p>
                    <p class="title">
                      Văn bản <br/>cần ký duyệt
                    </p>
                    <div class="icon">
                      <i class="isax-bold-user-edit"></i>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </el-card>
        </div>

        <div class="electronic-contract card card-md-12">
          <el-card>
            <div slot="header">
              <p class="card-header__title">Hợp đồng điện tử:</p>
            </div>
            <div class="card-body-md-12">
              <b-row>
                <b-col md="3" sm="6">
                  <div class="card-body__block total-contract__block" @click="goToPage('total-contract')">
                    <p class="count mb-4">
                      {{
                        electronicContract.totalContract >= 10 ?
                          electronicContract.totalContract :
                          "0" + electronicContract.totalContract
                      }}
                    </p>
                    <p class="title">
                      Tổng số <br/>hợp đồng
                    </p>
                    <div class="icon">
                      <i class="isax-bold-document-text-1"></i>
                    </div>
                  </div>
                </b-col>
                <b-col md="3" sm="6">
                  <div class="card-body__block progress-contract__block" @click="goToPage('progress-contract')">
                    <p class="count mb-4">
                      {{
                        electronicContract.progressContract >= 10 ?
                          electronicContract.progressContract :
                          "0" + electronicContract.progressContract
                      }}
                    </p>
                    <p class="title">
                      Hợp đồng <br/>đang thực hiện
                    </p>
                    <div class="icon">
                      <i class="isax-bold-document-copy"></i>
                    </div>
                  </div>
                </b-col>
                <b-col md="3" sm="6">
                  <div class="card-body__block approval-contract__block" @click="goToPage('need-approval-contract')">
                    <p class="count mb-4">
                      {{
                        electronicContract.needApprovedContract >= 10 ?
                          electronicContract.needApprovedContract :
                          "0" + electronicContract.needApprovedContract
                      }}
                    </p>
                    <p class="title">
                      Hợp đồng <br/>cần phê duyệt
                    </p>
                    <div class="icon">
                      <i class="isax-bold-edit-2"></i>
                    </div>
                  </div>
                </b-col>
                <b-col md="3" sm="6">
                  <div class="card-body__block expires-contract__block" @click="goToPage('approval-contract')">
                    <p class="count mb-4">
                      {{
                        electronicContract.approvedContract >= 10 ?
                          electronicContract.approvedContract :
                          "0" + electronicContract.approvedContract
                      }}
                    </p>
                    <p class="title">
                      Hợp đồng <br/>đã phê duyệt
                    </p>
                    <div class="icon">
                      <i class="isax-bold-note-favorite"></i>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </el-card>
        </div>

        <el-row :gutter="15" class="mb-3">
          <el-col :sm="24" :md="10">
            <div class="event__of__day card chart-card">
              <el-card>
                <div slot="header" class="header--flex">
                  <p class="card-header__title">Biểu đồ sự kiện trong ngày</p>
                  <el-select
                    v-model="shiftId"
                    placeholder="Chọn ca"
                    @change="changeShift"
                  >
                    <el-option
                      v-for="(item,index) in listShifts"
                      :key="index"
                      :label="item.code"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="card-body-md-12">
                  <div class="echart__block">
                    <EChart
                      v-if="showChartEventDay"
                      :chartId="'event'"
                      :optionChart="optionChartEventData"
                      @chartClick="chartClickEvent"
                    />
                  </div>
                  <div class="card__event__day--bottom">
                    <div class="event miss_company">
                      <span class="title">Vắng mặt:</span>
                      <span class="count">{{totalMissFace}}</span>
                    </div>
                    <div class="event in_company">
                      <span class="title">Có mặt:</span>
                      <span class="count">{{totalHaveFace}}</span>
                    </div>
                  </div>
                </div>
              </el-card>
            </div>
          </el-col>
          <el-col :sm="24" :md="14">
            <div class="event-of-day card chart-card">
              <el-card>
                <div slot="header">
                  <p class="card-header__title">Công việc quan trọng</p>
                </div>
                <div class="card-body-md-12">
                  <EChart
                    v-if="showChartTaskImportant"
                    :chartId="'task'"
                    :optionChart="optionChartTaskData"
                    :heightChart="'390'"
                    @chartClick="chartClickEvent"
                  />
                </div>
              </el-card>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="15" class="mb-3">
          <el-col :sm="24" :md="10">
            <div class="turn-over card chart-card">
              <el-card>
                <div slot="header" class="header--flex">
                  <p class="card-header__title">Doanh thu</p>
                  <div style="max-width: 120px;">
                    <el-select
                      v-model="turnOverCycle"
                      placeholder="Chọn kỳ"
                      @change="changeTurnOverType"
                    >
                      <el-option
                        v-for="(item,index) in listTurnOverType"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div
                  class="card-body-md-12"
                  v-if="haveDataTurnOver"
                >
                  <EChart
                    v-if="showChartTurnOver"
                    :chartId="'turnover'"
                    :optionChart="optionChartTurnOverData"
                    @chartClick="chartClickEvent"
                  />
                </div>
                <div
                  v-else
                  class="card-body-md-12 no-data"
                >
                  <p class="no-data__title">
                    Chưa có doanh thu nào trong vòng {{ turnOverCycle }} tháng qua.
                  </p>
                </div>
              </el-card>
            </div>
          </el-col>
          <el-col :sm="24" :md="14">
            <div class="monthly-revenue card chart-card">
              <el-card>
                <div slot="header">
                  <p class="card-header__title">Doanh thu theo tháng</p>
                </div>
                <div class="card-body-md-12">
                  <el-row :gutter="10">
                    <el-col :span="12" class="detail">
                      <div class="plan">
                        <div class="other-plan">
                          <p class="plan-text tagret">Kế hoạch</p>
                          <p class="value">{{ MethodService.formatCurrency(monthlyRevenueData.plan) }} đ</p>
                        </div>
                        <div class="other-plan">
                          <p class="plan-text turnover">Doanh thu <br/>đến ngày</p>
                          <p class="value">{{ MethodService.formatCurrency(monthlyRevenueData.turnover) }} đ</p>
                        </div>
                        <div class="other-plan mb-0">
                          <p class="plan-text complete">% Hoàn thành</p>
                          <p class="value">{{ monthlyRevenueData.complete }} %</p>
                        </div>
                      </div>
                      <div class="turnover__div">
                        <div class="turnover_div new-revenue">
                          <p class="turnover-title">
                            Doanh thu mới
                          </p>
                          <p class="value">
                            {{ MethodService.formatCurrency(monthlyRevenueData.newRevenue) }} đ
                          </p>
                        </div>
                        <div class="turnover_div sustained-revenue">
                          <p class="turnover-title">
                            Doanh thu duy trì
                          </p>
                          <p class="value">
                            {{ MethodService.formatCurrency(monthlyRevenueData.sustainedRevenue) }} đ
                          </p>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="12" class="chart">
                      <div class="chart-wrapper">
                        <EChart
                          v-if="showChartMonthlyRevenue"
                          :chartId="'turnover-month'"
                          :optionChart="optionChartMonthlyRevenueData"
                          @chartClick="chartClickEvent"
                        />
                        <div class="chart-wrapper-child" v-if="showChartMonthlyRevenue && monthlyRevenueData.complete > 0">
                          <p
                            class="data-up-trend"
                          >
                            {{monthlyRevenueData.complete}}%
                          </p>
                          <el-image
                            class="icon-up-trend"
                            src="img/icon-up-trend.png"
                            fit="cover"
                          />
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog
      class="dialog-employee__list"
      :title="`Danh sách nhân viên ${typeChartClick} (Tổng nhân viên: ${listEmployeeFromCharts.length})`"
      :visible.sync="dialogVisibleListEmployeeByType"
      :before-close="dialogBeforeClose"
    >
      <div class="employee__list">
        <el-table
          :data="listEmployeeFromCharts"
          style="width: 100%"
          border
        >
          <el-table-column
            label="Ảnh đại diện"
            width="120"
          >
            <template slot-scope="scope">
              <el-image
                class="avatar-employee"
                :src="getUrlIamge(scope.row)"
                fit="contain"
                lazy
              />
            </template>
          </el-table-column>
          <el-table-column prop="employee_no" label="Mã nhân viên" width="120" align="center" />
          <el-table-column prop="administrative_info.name.full_name" label="Họ và tên" min-width="150" />
          <el-table-column
            label="Thời gian chấm công"
            width="150"
            align="center"
            v-if="typeChartClick == 'Đi muộn'"
          >
            <template slot-scope="scope">
              {{ scope.row.time_checkin ? MethodService.formatDate(scope.row.time_checkin, 'aboutTime') : 'Chưa chấm công' }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MethodService from '../../../service/MethodService'
import ExtensionService from '../../../service/ExtensionService'
import EChart from '../../../component/EChart/EChart'
import DraffDocumentAutoApi from '../../../moduleApi/DraffDocumentAutoApi'
import DocumentApi from '../../../moduleApi/DocumentApi'
import TimeKeepingRawCurrentApi from '../../../moduleApi/TimeKeepingRawCurrentApi'
import EmployeeRequestApi from '../../../moduleApi/EmployeeRequestApi'
import EmployeeShiftApi from '../../../moduleApi/EmployeeShiftApi'
import EmployeeApi from '../../../moduleApi/EmployeeApi'
import ShiftApi from '../../../moduleApi/ShiftApi'
import UserApi from '../../../moduleApi/UserApi'
import BusinessPlanApi from '../../../moduleApi/BusinessPlanApi'
import * as moment from "moment"
import _ from "lodash"
import { Filter } from "mushroomjs"
export default {
  components: {
    EChart,
  },
  data() {
    return {
      MethodService,
      date: new Date(),
      firstDayInMonth: new Date(MethodService.getFirstDayOfMonth(new Date())).toISOString(),
      lastDayInMonth:  new Date(MethodService.getLastDayOfMonth(new Date())).toISOString(),
      totalEmployee: 0,
      totalRequestNeedApprove: 0,
      totalBusiness: 0,
      totalDayOff: 0,
      totalOnline: 0,
      totalOnTime: 0,
      totalMissFace: 0,
      totalHaveFace: 0,
      totalEmployeeNoNeedCheckin: 0,
      totalGoLate: 0,
      shiftId: undefined,
      listEmployees: [],
      listShifts: [],
      listEmployeeShift: [],
      listRequestMonths: [],
      listTimeKeepingRawCurrents: [],
      listEmployeeRequests: [],
      listEmployeeNoNeedCheckins: [],
      listEmployeeRequestsFilterBussiness: [],
      listEmployeeRequestsFilterDayOff: [],
      listEmployeeRequestsFilterOnline: [],
      listEmployee: [],
      listEmployeeRequestsFilterGoLate: [],
      listEmployeeFilterGoLate: [],
      optionChartEventData: {},
      shiftInfo: {},
      showChartEventDay: false,
      dialogVisibleListEmployeeByType: false,
      /*End Biểu đồ sự kiện ngày*/
      optionChartTaskData: {},
      optionChartTurnOverData: {},
      haveDataTurnOver: true,
      showChartTurnOver: false,
      typeChartClick: undefined,
      monthlyRevenueData: {
        plan: 0,
        turnover: 0,
        complete: 0,
        newRevenue: 0,
        sustainedRevenue: 0,
      },
      optionChartMonthlyRevenueData: {},
      showChartMonthlyRevenue: false,
      listTasks: [],
      listTurnovers: [],
      listSaleKpis: [],
      listEmployeeFromCharts: [],
      electronicDocument: {
        totalDocument: 0,
        incomingDocument: 0,
        unreadDocument: 0,
        documentToBeSigned: 0,
        documentToBeIssued: 0
      },
      electronicContract: {
        totalContract: 0,
        progressContract: 0,
        needApprovedContract: 0,
        approvedContract: 0
      },
      companyInfo: MethodService.getCompanyInfo(),
      currentUser: MethodService.getCurrentUser(),
      //Công việc
      listTodayTask: [],
      showChartTaskImportant: false,
      turnOverCycle: 3,
      listTurnOverType: [
        {
          label: "3 tháng",
          value: 3
        },
        {
          label: "6 tháng",
          value: 6
        },
        {
          label: "12 tháng",
          value: 12
        },
      ],
    }
  },
  methods: {
    chartClickEvent(dataEmit) {
      // console.log('dataEmit', dataEmit)
      if (dataEmit.seriesName == 'chartEventData') {
        if (dataEmit.name == 'Đúng giờ') return
        this.typeChartClick = dataEmit.name
        this.listEmployeeFromCharts = [];
        (dataEmit.data.datas || []).forEach(item => {
          let employee = this.getEmployeeInfo(item.employee_id)
          if (employee) {
            if (dataEmit.name == 'Đi muộn') {
              employee.time_checkin = item.time_checkin
            }
            this.listEmployeeFromCharts.push(employee)
          }
        })
        this.dialogVisibleListEmployeeByType = true
      } else if (dataEmit.seriesName == 'chartTaskData') {
        this.$router.push({
          name: 'Admin-AssignWork'
        }).catch(() => {})
      } else  if (
        dataEmit.seriesName == 'chartTurnOverData' ||
        dataEmit.seriesName == 'chartMonthlyRevenueData'
      ) {
        this.$router.push({
          name: 'Admin-Business-list'
        }).catch(() => {})
      }
    },
    getUrlIamge(employee) {
      let imageId
      if (employee.image_id) {
        imageId = employee.image_id
      } else if (employee.administrative_info.avatar_id) {
        imageId = employee.administrative_info.avatar_id
      }
      return `${ExtensionService.urlImg}${imageId}`
    },
    dialogBeforeClose(done) {
      this.listEmployeeFromCharts = []
      done()
    },
    getEmployeeInfo(employeId) {
      return this.listEmployee.find(em => em.id == employeId)
    },
    goToPage(type) {
      if (!type) return
      if (type == 'total') this.routerPush('Admin-DocumentsGeneral', { tab: 'TatCa' })
      if (type == 'unreadDocument') this.routerPush('Admin-DocumentsGeneral', { tab: 'TatCa', is_read: false })
      if (type == 'ElectronicDocument') this.routerPush('Admin-DocumentsGeneral', {tab: 'VanBanDen'})
      if (type == 'document-sign') this.routerPush('Admin-DocumentsGeneral', {tab: 'KyDuyet'})
      if (type == 'document-promulgate') return
      if (type == 'total-contract') this.routerPush('Admin-DocumentDrafting-list')
      if (type == 'progress-contract') this.routerPush('Admin-DocumentDrafting-list', {status: 'DangThucHien'})
      if (type == 'need-approval-contract') this.routerPush('Admin-DocumentDrafting-list', {status: 'ChoKy'})
      if (type == 'approval-contract') this.routerPush('Admin-DocumentDrafting-list', {status: 'DaKy'})
    },
    routerPush(name, query) {
      if (query) {
        this.$router.push({ name: name, query: query }).catch(err => {
          if (err.name != "NavigationDuplicated") {
            throw err;
          }
        });
      } else {
        this.$router.push({ name: name }).catch(err => {
          if (err.name != "NavigationDuplicated") {
            throw err;
          }
        });
      }
    },
    async initDataDefault() {
      Promise.all([
        ShiftApi.list({
          filters: "applied_end_time>=" + moment(new Date()).format("yyyy-MM-DD"),
          limit: 999999,
        }),
        UserApi.GetMyTodayTask({
          from: MethodService.getFirstDayOfMonth(new Date()),
          to: MethodService.getLastDayOfMonth(new Date())
        }),
      ]).then(promisesRes => {
        if (!promisesRes) return
        this.listShifts = promisesRes[0].result
        if (this.listShifts.length > 0) {
          this.shiftId = this.listShifts[0].id
          this.shiftInfo = this.listShifts[0]
          this.changeShift()
        }
        this.listTodayTask = promisesRes[1].result.tasks
        this.getListTaskImportant()
      })
    },
    async getDataBlockDocument() {
      const filter = Filter.or(
        Filter.and(
          Filter.eq("publish.publisher_to_ids", "$$user_id"),
          Filter.eq("status", "PUBLISHED")
        ),
        Filter.and(
          Filter.eq("signers.user_id", "$$user_id"),
          Filter.eq("status", "PUBLISHED"),
        ),
        Filter.and(
          Filter.elementMatch("signers", [
            Filter.eq("user_id", "$$user_id"),
            Filter.eq("status", "SIGNED"),
          ]),
          Filter.eq("status", "WAITING_FOR_SIGN")
        ),
        Filter.and(
          Filter.eq("signers.user_id", "$$user_id"),
          Filter.eq("status", "SIGNED"),
        ),
        Filter.and(
          Filter.eq("signers.user_id", "$$user_id"),
          Filter.eq("status", "RECALLED"),
        ),
        Filter.and(
          Filter.eq("signers.user_id", "$$user_id"),
          Filter.eq("status", "TRANSFERED_OTHER_COMPANY")
        ),
      ).build();
      Promise.all([
        // Lấy danh sách văn bản đến
        DocumentApi.list({
          filters: filter,
          limit: 1
        }),
        // Lấy danh sách văn bản chưa đọc
        // DocumentApi.list({
        //   filters: 'readers.employee_id!=$$user_id',
        //   limit: 1
        // }),
        // Lấy danh sách văn bản cần ký
        DocumentApi.list({
          filters: `&status=WAITING_FOR_SIGN&signers:elemMatch:user_id=$$user_id,status=WAITING`,
          limit: 1
        }),
        // Lấy danh sách văn bản
        DocumentApi.SearchDocument({
          is_read: false,
          limit: 1
        }),
        DocumentApi.SearchDocument({
          limit: 1
        })
      ]).then((res) => {
        if (res.length > 0) {
          // let count = 0
          // res[2].result.result.forEach(item => {
          //   let checkUnReader = (item.readers || []).find(e => e.employee_id == this.currentUser.id)
          //   if (!checkUnReader) {
          //     count++
          //   }
          // })
          this.electronicDocument = {
            incomingDocument: res[0].meta.total,
            documentToBeSigned: res[1].meta.total,
            unreadDocument: res[2].meta.total,
            totalDocument: res[3].meta.total,
          }
        }
      })
    },
    async getDataBlockContract() {
      Promise.all([
        DraffDocumentAutoApi.list({
          limit: 1
        }),
        DraffDocumentAutoApi.list({
          filters: 'status:in:DRAFF,GENERATING,COMPLETED,FAILED',
          limit: 1
        }),
        DraffDocumentAutoApi.list({
          filters: 'status:in:SIGN_WAITING',
          limit: 1
        }),
        DraffDocumentAutoApi.list({
          filters: 'status:in:SIGN_APPROVED',
          limit: 1
        }),
      ]).then(res => {
        if (res.length > 0) {
          this.electronicContract = {
            totalContract: res[0].meta.total,
            progressContract: res[1].meta.total,
            needApprovedContract: res[2].meta.total,
            approvedContract: res[3].meta.total,
          }
        }
      })
    },
    /*
    * Lấy dữ liệu data chart biểu đồ sự kiện trong ngày
    */
    clearData() {
      this.totalBusiness = 0
      this.totalDayOff = 0
      this.totalOnline = 0
      this.totalOnTime = 0
      this.totalMissFace = 0
      this.totalHaveFace = 0
      this.totalEmployeeNoNeedCheckin = 0
      this.totalGoLate = 0
    },
    async getCountEventInDay() {
      this.showChartEventDay = false;
      this.clearData()
      this.year = this.date.getFullYear();
      this.month = this.date.getMonth() + 1;
      this.dayOfWeek = this.date.getDay();
      this.startDay = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate(), 0, 0, 0).toISOString();
      this.endDay = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate(), 23, 59, 59).toISOString();
      let dataFilterTimeKeepingRaw = {
        filters: "time>=" + this.startDay + "&time<=" + this.endDay,
        limit: 9999999,
        sort: "-time"
      };
      let dataFilterEmployeeRequestOnDay = {
        cid: this.companyInfo.id,
        sid: this.shiftId,
        sd: this.startDay,
        ed: this.endDay
      }
      const timeKeepingRawApiReq = TimeKeepingRawCurrentApi.list(
        dataFilterTimeKeepingRaw
      );
      const employeeRequestReq = EmployeeRequestApi.getListEmployeeRequest(
        dataFilterEmployeeRequestOnDay
      );
      const timeKeepingRawApiRes = await timeKeepingRawApiReq;
      const employeeRequestRes = await employeeRequestReq;
      this.listTimeKeepingRawCurrents =  timeKeepingRawApiRes.result;
      this.listEmployeeRequests = employeeRequestRes.result;
      this.listEmployeeNoNeedCheckins = this.fn_checkNoTimekeepingRequired(this.listEmployeeShift);

      let arrTimeKeepingCurrentUnique = _.uniqBy(
        this.listTimeKeepingRawCurrents,
        x => [x.employee_no].join()
      );
      let arrEmployeeCheckinAfterFilter = [];
      arrTimeKeepingCurrentUnique.forEach(x => {
        let check = this.listEmployee.find(e => {
          return e.employee_no == x.employee_no
        })
        if (check) {
          x.employee_id = check.id;
          arrEmployeeCheckinAfterFilter.push(x);
        }
      })
        let listEmployeeRequestFilter = this.listEmployeeRequests.filter(item => {
          return  (item.type == "DAY_OFF" && item.status == "APPROVED") ||
                  (item.type == "GO_ON_BUSSINESS" && item.status == "APPROVED") ||
                  (item.type == "TIME_KEEPING_ONLINE") ||
                  (item.type == "GO_LATE" && item.status == "APPROVED")
        })
        listEmployeeRequestFilter.forEach(item => {
          if (item.type == "GO_ON_BUSSINESS" && item.status == "APPROVED") {
            this.listEmployeeRequestsFilterBussiness.push(item);
            this.totalBusiness++;
          }
          if (item.type == "DAY_OFF" && item.status == "APPROVED") {
            let dayOffShift = item.day_off.find(e => e.shift_id == this.shiftId && new Date(e.day).getTime() == new Date(this.startDay).getTime());
            if (
              dayOffShift &&
              (
                (dayOffShift.odd_shifts.length == 1 && dayOffShift.odd_shifts[0] == 1) ||
                (
                    dayOffShift.odd_shifts.length == 2 &&
                      ((dayOffShift.odd_shifts[0] == 1 && dayOffShift.odd_shifts[1] == 1) || (dayOffShift.odd_shifts[0] == 0 && dayOffShift.odd_shifts[1] == 1) || (dayOffShift.odd_shifts[0] == 1 && dayOffShift.odd_shifts[1] == 0))
                )
              )
            ) {
              this.listEmployeeRequestsFilterDayOff.push(item);
              this.totalDayOff++;
            }
          }
          if (
            item.type == "TIME_KEEPING_ONLINE" && item.status != "REJECTED"
          ) {
            let checkHaveRequestWithEmployeeNoNeedCheckin = this.listEmployeeNoNeedCheckins.find(e => e.employee_no == item.employee_no);
            if (checkHaveRequestWithEmployeeNoNeedCheckin) return
            this.listEmployeeRequestsFilterOnline.push(item)
            this.totalOnline++;
          }
          if (item.type == "GO_LATE"  && item.status == "APPROVED") {
            this.listEmployeeRequestsFilterGoLate.push(item);
          }
        });
        let promises = this.listEmployee.map(async item => {
          let checkExist = this.listEmployeeNoNeedCheckins.find(x => {
            return x.employee_no == item.employee_no
          })
          if (checkExist) return
          return await this.fn_checkOnTime(this.dayOfWeek, item.employee_no, item.id);//employee_id nếu là lọc theo arrEmployeeCheckinAfterFilter
        });
        Promise.all(promises).then(values => {
          if (this.totalEmployee == 0) this.totalHaveFace = 0;
          this.totalOnTime = values.filter(x => x && x.value).length
          this.listEmployeeFilterGoLate = values.filter(x => x && x.employee_id && !x.value)
          this.totalMissFace = this.totalEmployee == 0  ? 0 :this.totalEmployee - this.totalHaveFace;
          this.totalEmployeeNoNeedCheckin = this.listEmployeeNoNeedCheckins.length;
          this.totalGoLate =
            this.totalEmployee -
            this.totalOnTime -
            this.totalEmployeeNoNeedCheckin -
            (this.totalBusiness +
              this.totalDayOff +
              this.totalOnline);
          let arrFilter = [];
          let arrFilterIgnoreNoNeedCheckin = [];
          let arrFilterIgnoreBussiness = [];
          let arrFilterIgnoreDayOff = [];
          arrFilter = _.differenceBy(this.listEmployeeFilterGoLate, this.listEmployeeRequestsFilterOnline, 'employee_id');
          arrFilterIgnoreNoNeedCheckin = _.differenceBy(arrFilter, this.listEmployeeNoNeedCheckins, 'employee_id');
          arrFilterIgnoreBussiness = _.differenceBy(arrFilterIgnoreNoNeedCheckin, this.listEmployeeRequestsFilterBussiness, 'employee_id');
          arrFilterIgnoreDayOff = _.differenceBy(arrFilterIgnoreBussiness, this.listEmployeeRequestsFilterDayOff, 'employee_id');
          this.listEmployeeFilterGoLate = arrFilterIgnoreDayOff;
          setTimeout(() => {
            this.setDataChartDayEvent();
          }, 100);
        });
    },
    fn_checkNoTimekeepingRequired(arrEmployeeShift){
      let arrNoNeedCheckin = [];
      let arr = [];
      arr = arrEmployeeShift.filter(x => {
        return x.is_need_checkin === false
      })
      arr.forEach(y => {
        let checkExist = arrNoNeedCheckin.find(z => {
          return z.employee_id == y.employee_id
        })
        let employee = this.listEmployee.find(i => {
          return i.id == y.employee_id
        })
        if (!checkExist) {
          if (employee) {
            y.employee_no = employee.employee_no;
            arrNoNeedCheckin.push(y);
          }
        }
      })
      return arrNoNeedCheckin
    },
    async fn_checkOnTime(day, employeeNo, employeeId) {
      let check = undefined;
      let workDay = undefined;
      let dayOffFullDay = false;
      let dayOffFirstOddShift = false;
      let dayOffSeconOddShift = false;
      let haveDayOff = false;
      let firstTimeLog = undefined;
      let firstTimeOfShift = undefined;
      let endTimeOfShift = undefined;
      let firstTimeShiftDay = undefined;
      let endTimeShiftDay = undefined;
      //Check có yêu cầu đi muộn hay không
      let checkHaveRequestGoLate = this.listEmployeeRequestsFilterGoLate.find(request => request.employee_no == employeeNo);
      //Check dayoff thuộc loại nghỉ nào
      let checkDayOff = this.listEmployeeRequestsFilterDayOff.find(b => {
        return b.employee_id == employeeId;
      })
      if (checkDayOff) {
        haveDayOff = true;
        let checkDayoffOddDay = checkDayOff.day_off.find(c => {
          return c.shift_id == this.shiftId
        })
        if (checkDayoffOddDay) {
          if (
            (checkDayoffOddDay.odd_shifts.length == 1 && checkDayoffOddDay.odd_shifts[0] == 1) ||  //Check nếu odd_shift có dộ dài bằng 1 và phần tử đầu tiên == 1 => nghỉ cả ngảy
            (checkDayoffOddDay.odd_shifts.length == 2 && checkDayoffOddDay.odd_shifts[0] == 1 && checkDayoffOddDay.odd_shifts[1] == 1 )
          ) {
            dayOffFullDay = true;
            dayOffFirstOddShift = false;
            dayOffSeconOddShift = false;
          } else if (checkDayoffOddDay.odd_shifts.length == 2 && checkDayoffOddDay.odd_shifts[0] == 0 && checkDayoffOddDay.odd_shifts[1] == 1) {
            dayOffFullDay = false;
            dayOffFirstOddShift = false;
            dayOffSeconOddShift = true;
          } else if (checkDayoffOddDay.odd_shifts.length == 2 && checkDayoffOddDay.odd_shifts[0] == 1 && checkDayoffOddDay.odd_shifts[1] == 0) {
            dayOffFullDay = false;
            dayOffFirstOddShift = true;
            dayOffSeconOddShift = false;
          }
        }
      }
      if (haveDayOff === true && dayOffFullDay === true) {
        check = undefined;
        return
      }
      let emp = this.listEmployee.find(x => {
        return x.employee_no == employeeNo;
      });
      if (!emp) return;
      let dayShift = (day + 1).toString();
      //Truyền thêm vào thời gian bắt đầu của ca, sau đó so sánh giờ
      if (this.shiftInfo.work_days && this.shiftInfo.work_days.length > 0) {
        workDay = this.shiftInfo.work_days.find(x => {
          return (
            ((x.period_time &&
              x.period_time[0] &&
              x.period_time[0].start_time &&
              x.period_time[0].start_time.hour) ||
              (x.period_time &&
                x.period_time[0] &&
                x.period_time[0].start_time &&
                !x.period_time[0].start_time.hour &&
                x.period_time &&
                x.period_time[1] &&
                x.period_time[1].start_time &&
                x.period_time[1].start_time.hour)) &&
            x.name == dayShift
          );
        });
      }
      if (workDay != undefined) {
        //Lấy giờ kết thúc của ca
        if (
          (workDay.period_time &&
          workDay.period_time[0] &&
          workDay.period_time[0].start_time &&
          workDay.period_time[0].start_time.hour) &&
          (workDay.period_time &&
          workDay.period_time[1] &&
          workDay.period_time[1].start_time &&
          workDay.period_time[1].start_time.hour)
        ) {
          firstTimeShiftDay = new Date(this.year, this.month - 1, new Date().getUTCDate(), workDay.period_time[0].start_time.hour, workDay.period_time[0].end_time.minute + 1);
          endTimeShiftDay = new Date(this.year, this.month - 1, new Date().getUTCDate(), workDay.period_time[1].end_time.hour, workDay.period_time[1].end_time.minute + 1);
        } else {
          firstTimeShiftDay = new Date(this.year, this.month - 1, new Date().getUTCDate(), workDay.period_time[0].start_time.hour, workDay.period_time[0].end_time.minute + 1);
          endTimeShiftDay = new Date(this.year, this.month - 1, new Date().getUTCDate(), workDay.period_time[0].end_time.hour, workDay.period_time[0].end_time.minute + 1);
        }
        //Check giờ bắt đầu/kết thúc của từng ca lẻ
        if (
          (workDay.period_time &&
          workDay.period_time[0] &&
          workDay.period_time[0].start_time &&
          workDay.period_time[0].start_time.hour) && haveDayOff == false
        ) {
          firstTimeOfShift = new Date(this.year, this.month - 1, new Date().getUTCDate(), workDay.period_time[0].start_time.hour, workDay.period_time[0].start_time.minute + 1);
          endTimeOfShift = new Date(this.year, this.month - 1, new Date().getUTCDate(), workDay.period_time[0].end_time.hour, workDay.period_time[0].end_time.minute + 1);
        } else if (
          (workDay.period_time &&
          workDay.period_time[0] &&
          workDay.period_time[0].start_time &&
          workDay.period_time[0].start_time.hour) && haveDayOff == true && dayOffSeconOddShift === true
        ) {
          firstTimeOfShift = new Date(this.year, this.month - 1, new Date().getUTCDate(), workDay.period_time[0].start_time.hour, workDay.period_time[0].start_time.minute + 1);
          endTimeOfShift = new Date(this.year, this.month - 1, new Date().getUTCDate(), workDay.period_time[0].end_time.hour, workDay.period_time[0].end_time.minute + 1);
          if (new Date().getTime() > firstTimeOfShift.getTime() && new Date().getTime() < endTimeOfShift.getTime()) {
            this.listEmployeeRequestsFilterDayOff = this.listEmployeeRequestsFilterDayOff.filter((el) => el.employee_id !== employeeId);
            this.totalDayOff--;
          }
        } else {
          firstTimeOfShift = new Date(this.year, this.month - 1, new Date().getUTCDate(), workDay.period_time[1].start_time.hour, workDay.period_time[1].start_time.minute + 1);
          endTimeOfShift = new Date(this.year, this.month - 1, new Date().getUTCDate(), workDay.period_time[1].end_time.hour, workDay.period_time[1].end_time.minute + 1);
          if (new Date().getTime() > firstTimeOfShift.getTime() && new Date().getTime() < endTimeOfShift.getTime()) {
            this.listEmployeeRequestsFilterDayOff = this.listEmployeeRequestsFilterDayOff.filter((el) => el.employee_id !== employeeId);
            this.totalDayOff--;
          }
        }
        if (checkHaveRequestGoLate) {
          firstTimeOfShift = checkHaveRequestGoLate.extra_minute_go_late;
        }
        //Nếu thời gian check in lớn hơn giờ bắt đầu của ca thì đi muộn và ngược lại
        firstTimeLog = await this.fn_getFirstTimeLog(employeeNo,firstTimeOfShift);
        let currentTime = new Date().getTime();
        //Nghỉ sáng làm chiều
        if (haveDayOff === true && dayOffFirstOddShift === true && (currentTime > new Date(firstTimeOfShift).getTime() && currentTime < new Date(endTimeOfShift).getTime()) && firstTimeLog === null) {
          check = undefined;
        }
        //Nghỉ chiều làm sáng
        else if (haveDayOff === true &&  dayOffSeconOddShift === true && (currentTime < new Date(endTimeOfShift).getTime()) && firstTimeLog === null) {
          check = undefined;
        } else {
          if (
            !firstTimeLog ||
            (new Date(firstTimeLog).getTime() > new Date(firstTimeOfShift).getTime())
          ) {
            check = false;
          } else if (firstTimeLog && new Date(firstTimeLog).getTime() < new Date(firstTimeOfShift).getTime()) {
            check = true;
          }
          // lấy số lượng nhân viên có mặt
          if (
            new Date(firstTimeLog).getTime() <= new Date(firstTimeShiftDay).getTime() ||
            (new Date(firstTimeLog).getTime() <= new Date(endTimeShiftDay).getTime() &&
            new Date(firstTimeLog).getTime() >= new Date(firstTimeShiftDay).getTime())
          ) {
            if (dayOffFirstOddShift && (currentTime > new Date(firstTimeOfShift).getTime() && currentTime < new Date(endTimeOfShift).getTime())) {
              this.totalHaveFace++;
            }
            if (dayOffSeconOddShift && (currentTime > new Date(firstTimeOfShift).getTime() && currentTime < new Date(endTimeOfShift).getTime())) {
              this.totalHaveFace++;
            }
            if (dayOffFirstOddShift && (firstTimeLog && new Date(firstTimeLog).getTime() < new Date(firstTimeOfShift).getTime()) && (currentTime < new Date(firstTimeOfShift).getTime() || currentTime > new Date(endTimeOfShift).getTime())) {
              check = undefined;
            }
            if (dayOffSeconOddShift && (firstTimeLog && new Date(firstTimeLog).getTime() < new Date(firstTimeOfShift).getTime()) && (currentTime < new Date(firstTimeOfShift).getTime() || currentTime > new Date(endTimeOfShift).getTime())) {
              check = undefined;
            }
            if (!haveDayOff) {
              this.totalHaveFace++;
            }
          }
        }

      }
      return {
        employee_id: employeeId,
        time_checkin: firstTimeLog,
        value: check
      }
    },

    fn_getFirstTimeLog(employeeNo,firstTimeOfShift) {
      let timeBefore = undefined;
      let timeAfter = undefined;
      let arrTimeBefore = this.listTimeKeepingRawCurrents.filter(
        item => {
          return item.employee_no == employeeNo && new Date(item.time).getTime() < new Date(firstTimeOfShift).getTime();
        }
      );
      timeBefore = this.sortTimeDesc(arrTimeBefore)[0];
      let arrTimeAfter = this.listTimeKeepingRawCurrents.filter(
        item => {
          return item.employee_no == employeeNo && new Date(item.time).getTime() > new Date(firstTimeOfShift).getTime();
        }
      );
      timeAfter = this.sortTimeAsc(arrTimeAfter)[0];
      return timeBefore != undefined ? timeBefore.time :
              timeAfter != undefined ? timeAfter.time : undefined;
    },
    //Sort giảm dần
    sortTimeDesc(arr){
      return arr.sort(function(a, b) {
        return new Date(b.time).getTime() - new Date(a.time).getTime();
      });
    },
    //Sort tăng dần
    sortTimeAsc(arr){
      return arr.sort(function(a, b) {
        return new Date(a.time).getTime() - new Date(b.time).getTime();
      });
    },
    async changeShift() {
      await this.fn_getEmployeeFromShift(this.shiftId);
      await this.fn_getTotalRequestFromShift(this.shiftId);
      this.shiftInfo = this.listShifts.find(e => {
        return e.id == this.shiftId
      })
      this.getCountEventInDay();
    },
    /*
    * End lấy dữ liệu data chart biểu đồ sự kiện trong ngày
    */
    //Lấy toàn bộ yêu cầu của nhân viên theo shift đã chọn
    async fn_getTotalRequestFromShift(shiftId){
      // try {
      //   var date = new Date();
      //   var firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
      //   var lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0,23,59,59);
      //   let dataFilterEmployeeRequestTotal = {
      //     cid: this.companyInfo.id,
      //     sid: shiftId,
      //     sd: firstDayOfMonth,
      //     ed: lastDayOfMonth
      //   };
      //   const employeeRequestTotalApiRes = await EmployeeRequestApi.getListEmployeeRequest(
      //     dataFilterEmployeeRequestTotal
      //   );
      //   let requestWFA = employeeRequestTotalApiRes.result.filter(e => {
      //    return e.status == "WAITING_FOR_APPROVAL"
      //   })
      //   this.listRequestMonths = employeeRequestTotalApiRes.result;
      //   let checkequest = _.intersectionBy(requestWFA, this.listEmployee, 'employee_no');
      //   if (checkequest.length == 0) {
      //     this.totalRequestNeedApprove = 0;
      //   } else {
      //     this.totalRequestNeedApprove = requestWFA.length;
      //   }
      // } catch (error) {
      //   console.log("error",error);
      // }
    },
    //Lấy danh sách nhân viên theo ca làm việc đã chọn
    async fn_getEmployeeFromShift(shiftId){
      let filter = Filter.and(
        Filter.eq('shift_id', shiftId),
        Filter.or(
          Filter.and(
            Filter.lte('start_time', this.firstDayInMonth),
            Filter.isNull('end_time')
          ),
          Filter.and(
            Filter.lte('start_time', this.firstDayInMonth),
            Filter.gte('end_time', this.lastDayInMonth)
          ),
          Filter.and(
            Filter.gte('start_time', this.firstDayInMonth),
            Filter.isNull('end_time')
          ),
          Filter.and(
            Filter.lte('start_time', MethodService.getCurrentDate()),
            Filter.isNull('end_time')
          ),
          Filter.and(
            Filter.lte('start_time', MethodService.getCurrentDate()),
            Filter.gte('end_time', MethodService.getCurrentDate())
          )
        )
      ).build()
      let dataFilterEmployeeShift = {
          limit: 1000,
          filters: filter,
          sort: "employee_id"
        };
        const employeeShiftApiRes = await EmployeeShiftApi.list(
          dataFilterEmployeeShift
        );
        let arrEmployeeInShift = _.uniqBy(
          employeeShiftApiRes.result,
          x => [x.employee_id].join()
        );
        this.listEmployeeShift = arrEmployeeInShift;
        let employeeIds = [];
        employeeIds = MethodService.findListItemDifferent(
          arrEmployeeInShift,
          "employee_id"
        );
        const employeeApiRes = await EmployeeApi.list({
          filters: "id:in:"+employeeIds.join(","),
          limit: employeeIds.length
        })
        this.listEmployee = employeeApiRes.result.filter(e => {
          return e.status == "DANG_LAM_VIEC"
        })
        this.totalEmployee = this.listEmployee.length;
    },
    setDataChartDayEvent() {
      this.optionChartEventData = {
        tooltip: {
          trigger: 'item',
          formatter: `
            Biểu đồ sự kiện trong ngày <br/>
            {b} :  {c}
          `,
          textStyle: {
            fontSize: 16,
            fontFamily: 'UTM Avo',
            fontWeight: 400,
          }
          //{d}%
        },
        series: [
          {
            name: 'chartEventData',
            type: 'pie',
            radius: '80%',
            center: ['50%', '50%'],
            color: ['#F79D61', '#007AFF', '#FF5A5A', '#FECC41', '#1597e5', '#30F363'],
            label: {
              fontSize: 14,
              fontWeight: 'bold',
              fontFamily: 'UTM Avo',
            },
            data: [
              {
                value: this.totalGoLate == 0 ? undefined : this.totalGoLate,
                name: 'Đi muộn',
                datas: this.listEmployeeFilterGoLate
              },
              {
                value: this.totalBusiness == 0 ? undefined : this.totalBusiness,
                name: 'Công tác',
                datas: this.listEmployeeRequestsFilterBussiness
              },
              {
                value: this.totalDayOff == 0 ? undefined : this.totalDayOff,
                name: 'Nghỉ phép',
                datas: this.listEmployeeRequestsFilterDayOff
              },
              {
                value: this.totalOnline == 0 ? undefined : this.totalOnline,
                name: 'Remote',
                datas: this.listEmployeeRequestsFilterOnline
              },
              {
                value: this.totalEmployeeNoNeedCheckin == 0 ? undefined : this.totalEmployeeNoNeedCheckin,
                name: 'VIP',
                datas: this.listEmployeeNoNeedCheckins
              },
              { value: this.totalOnTime == 0 ? undefined : this.totalOnTime, name: 'Đúng giờ' },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 5,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      }

      this.showChartEventDay = true;
    },
    /*
    * Kết thúc hàm lấy dữ liệu biểu đồ sự kiện trong ngày
    */
    getListTaskImportant() {
      let data = [
        { value: 0, name: 'Chưa thực hiện' },
        { value: 0, name: 'Hoàn thành' },
        { value: 0, name: 'Đang thực hiện' },
      ]
      this.listTodayTask.forEach(item => {
        if (item.status == 'NOT_STARTED') {
          data[0].value += 1
        } else if (item.status == 'COMPLETED') {
          data[1].value += 1
        } else if (
          item.status == 'IN_PROGRESS'
        ) {
          data[2].value += 1
        }
      })
      if (data[0].value == 0) data[0].value = ''
      if (data[1].value == 0) data[1].value = ''
      if (data[2].value == 0) data[2].value = ''
      this.setDataChartTaskImportant(data)
    },
    setDataChartTaskImportant(data) {
      this.showChartTaskImportant = false
      this.optionChartTaskData = {
        legend: {
          icon: 'circle',
          orient: 'horizontal',
          left: 'center',
          itemGap: 30,
          itemWidth: 15,
          textStyle: {
            fontSize: 15,
            fontFamily: 'UTM Avo',
          },
        },
        series: [
          {
            name: 'chartTaskData',
            type: 'pie',
            top: '7%',
            radius: ['50%', '80%'],
            color: ['#FF731D', '#30F363', '#02D0FD'],
            label: {
              fontSize: 15,
              fontWeight: 'bold',
              fontFamily: 'UTM Avo',
              width: 100,
              overflow: 'break',
              formatter: `{c} việc`
            },
            avoidLabelOverlap: true,
            // width: '85%',
            data: data,
            emphasis: {
              itemStyle: {
                shadowBlur: 5,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      }
      setTimeout(() => {
        this.showChartTaskImportant = true
      }, 1000);
    },
    changeTurnOverType() {
      this.getTurnover()
    },
    async getTurnover() {
      let dataLabel = []
      let dataRevenue = []
      let date = new Date(), y = date.getFullYear(), m = date.getMonth() + 1
      let fromDate
      if (m < this.turnOverCycle) {
        let year = y - 1
        let month = m + 12 - this.turnOverCycle
        fromDate = new Date(year, month, 1)
      } else {
        let month = m - this.turnOverCycle
        fromDate = new Date(y, month, 1)
      }
      let toDate = new Date(y, m, 0, 23, 59, 59)
      Promise.all([
        BusinessPlanApi.StatisticRevenueOnMonth({
          from_date: fromDate,
          to_date: toDate,
        }),
      ]).then(apiRes => {
        if (apiRes[0].result && apiRes[0].result.length == 0) {
          this.haveDataTurnOver = false
          return
        }
        this.haveDataTurnOver = true
        apiRes[0].result.forEach(item => {
          dataLabel.push(`${item.Month}/${item.Year}`)
          dataRevenue.push(item.TotalRevenue)
        })
        this.setDataChartTurnOver(dataLabel, dataRevenue)
      })
    },
    setDataChartTurnOver(dataLabel, dataRevenue) {
      this.showChartTurnOver = false
      this.optionChartTurnOverData = {
        xAxis: {
          type: 'category',
          data: dataLabel
        },
        yAxis: {
          type: 'value'
        },
        grid: {
          top: '2%',
          left: '2%',
          right: '2%',
          bottom: '1%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: (params) => {
            return  `<b>Doanh thu ${params[0].name}</b> <br/>
                    ${MethodService.formatCurrency(params[0].value)} VNĐ`
          },
          textStyle: {
            fontSize: 16,
            fontFamily: 'UTM Avo',
            fontWeight: 400,
          }
        },
        series: [
          {
            name: 'chartTurnOverData',
            data: dataRevenue,
            type: 'bar',
            barWidth: '50%',
            color: "#017EFA"
          }
        ]
      }
      setTimeout(() => {
        this.showChartTurnOver = true
      }, 1000);
    },
    getSaleKpi() {
      Promise.all([
        BusinessPlanApi.StatisticCurrentMonthRevenue(),
      ]).then(apiRes => {
        let new_revenue = apiRes[0].result.new_revenue ? apiRes[0].result.new_revenue : 0
        let main_tain_revenue = apiRes[0].result.main_tain_revenue ? apiRes[0].result.main_tain_revenue : 0
        let expectedRevenue = apiRes[0].result.expectedRevenue
        this.monthlyRevenueData = {
          plan: expectedRevenue,
          turnover: new_revenue + main_tain_revenue,
          newRevenue: new_revenue,
          sustainedRevenue: main_tain_revenue,
        }
        if (expectedRevenue == 0 && this.monthlyRevenueData.turnover == 0) {
          this.monthlyRevenueData.complete = 0
        } else if (expectedRevenue == 0 && this.monthlyRevenueData.turnover > 0) {
          this.monthlyRevenueData.complete = 100
        } else {
          this.monthlyRevenueData.complete = MethodService.mathRound(
            (new_revenue + main_tain_revenue)
            / expectedRevenue
            * 100
          )
        }
        this.setDataChartSaleKpi()
      })
    },
    setDataChartSaleKpi() {
      this.showChartMonthlyRevenue = false
      this.optionChartMonthlyRevenueData = {
        title: {
          text: `Tháng ${new Date().getMonth() + 1} / ${new Date().getFullYear()}`,
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            return  `<b style="font-family: Roboto;">${params.data.dataName}</b> <br/>
              <p
                style="
                  font-size: 17px;
                  font-family: Roboto;
                  font-weight: 600;
                  color: ${params.data.dataType == 'complete' ? '#FD8101' : '#FF5858'};
                  text-align: center;
                "
              >${params.data.value} %</p>
            `
          },
        },
        series: [
          {
            name: 'chartMonthlyRevenueData',
            type: 'pie',
            radius: ['35%', '65%'],
            color: ['#FD8101', '#F2F2F2'],
            label: {
              show: false,
              position: 'center',
            },
            data: [
              {
                name: this.monthlyRevenueData.complete,
                dataType: 'complete',
                dataName: 'Hoàn thành',
                value: this.monthlyRevenueData.complete,
              },
              {
                name: 100 - this.monthlyRevenueData.complete,
                dataType: 'uncomplete',
                dataName: 'Chưa hoàn thành',
                value: 100 - this.monthlyRevenueData.complete,
              },
            ],
            labelLine: {
              show: false,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 5,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
              // label: {
              //   show: true,
              //   fontSize: '25',
              //   fontWeight: 'bold',
              // }
            },
          },
        ],
      }
      setTimeout(() => {
        this.showChartMonthlyRevenue = true
      }, 1000);
    },
  },
  created(){
    this.initDataDefault();
    this.getDataBlockDocument();
    this.getDataBlockContract();
    // this.getCountEventInDay();
    this.getTurnover();
    this.getSaleKpi();
  }
}
</script>

<style lang="scss" scoped>
.main-body__css{
  .card-md-12 {
    margin-bottom: 14px;
  }
}
::v-deep .el-card {
  .el-card__header{
    padding: 15px 15px 10px 15px;
    width: 100%;
    min-height: 57px;
    vertical-align: middle;
    .card-header__css {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .card-header__title{
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 700;
      font-size: 15px;
      line-height: 18px;
      color: #000000;
    }
  }
  .el-card__body{
    padding: 0 10px 15px 10px;
  }
}
::v-deep .chart-card {
  .el-card__body{
    min-height: 385px;
  }
}
::v-deep .card-body-md-12{
  [class^="col-"], [class*=" col-"] {
    padding-right: 5px;
    padding-left: 5px;
  }
  .card-body__block{
    position: relative;
    height: 120px;
    border-radius: 10px;
    color: #FFFFFF;
    padding: 17px 23px;
    &:hover {
      cursor: pointer;
    }
    .count {
      font-family: 'Roboto';
      font-weight: 700;
      font-size: 26px;
      line-height: 28px;
      color: #FFFFFF;
    }
    .title {
      font-family: 'Roboto';
      font-weight: 500;
      font-size: 16px;
      line-height: 19px;
      color: #FFFFFF;
      width: 120px;
    }
    .icon {
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
      right: 25px;
      [class^="isax-bold-"] {
        &::before {
          font-size: 40px;
          line-height: 40px;
        }
      }
    }
    &.document-in__block{
      background: #34AA4A;
    }
    &.document-unread__block{
      background: #4DB749;
    }
    &.document-sign__block{
      background: #84C341;
    }
    &.document-promulgate__block{
      background: #B4D433;
    }
    &.total-contract__block{
      background: #0AB8B6;
    }
    &.progress-contract__block{
      background: #4690CD;
    }
    &.approval-contract__block{
      background: #3753A6;
    }
    &.expires-contract__block{
      background: #5A51A2;
    }
  }
}
::v-deep .event__of__day {
  .el-card__header {
    .header--flex {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-select {
        max-width: 160px;
        .el-input__inner {
          height: 30px !important;
        }
      }
    }
  }
  .el-card__body {
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    .echart__block {
      min-height: 370px;
    }
    .card__event__day--bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-grow: 2;
    }
    .event {
      width: 100%;
      height: 35px;
      padding-left: 13px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      span {
        color: #fff;
      }
      &.miss_company {
        background: #575757;
      }
      &.in_company {
        background: #0ABF02;
      }
      .title {
        width: 70%;
        font-weight: 500;
        font-size: 15px;
        line-height: 16px;
      }
      .count {
        width: 30%;
        font-weight: 600;
        font-size: 16px;
        line-height: 16px;
      }
    }
  }
}
::v-deep .el-card__header {
  .header--flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .el-select {
      max-width: 160px;
      .el-input__inner {
        height: 30px !important;
      }
    }
  }
}
.no-data {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 370px;
  &__title {
    margin-bottom: 0;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 19px;
    color: #000000;
  }
}
::v-deep .monthly-revenue {
  .detail {
    margin-top: 10px;
    .plan {
      padding-left: 10px;
      max-width: 400px;
      .other-plan {
        margin-bottom: 38px;
        display: flex;
        justify-content: space-between;
        .plan-text {
          font-family: 'Roboto';
          text-transform: uppercase;
          font-weight: 700;
          font-size: 16px;
          line-height: 18px;
          max-width: 120px;
          &.tagret {
            color: #ED191C;
          }
          &.turnover {
            color: #007AFF;
          }
          &.complete {
            color: #0ABF02;
          }
        }
        .value {
          font-family: 'Roboto';
          font-weight: 700;
          font-size: 20px;
          line-height: 23px;
        }
      }
    }
    .turnover__div {
      margin-top: 60px;
      max-width: 400px;
      padding-left: 10px;
      .turnover_div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 10px;
        padding-bottom: 10px;
        padding-right: 7px;
        padding-left: 5px;
      }
      .new-revenue {
        border-bottom: 1px solid #444242;
      }
      .turnover-title {
        font-family: 'Roboto';
        font-weight: 400;
        font-size: 15px;
        line-height: 16px;
        color: #000000;
      }
      .value {
        font-family: 'Roboto';
        font-weight: 600;
        font-size: 15px;
        line-height: 16px;
        color: #000000;
      }
    }
  }
}
.chart-wrapper {
  position: relative;
  &-child {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .data-up-trend {
      font-family: 'Roboto';
      font-weight: 600;
      font-size: 14px;
      line-height: 23px;
      color: #FD8101;
      margin-bottom: 0px;
      text-align: center;
    }
    .icon-up-trend {
      width: 80px;
    }
  }
}
::v-deep .dialog-employee__list {
  .el-dialog {
    width: 780px;
    margin-top: 6vh !important;
    .el-dialog__body {
      padding-left: 30px;
      padding-right: 30px;
      .employee__list {
        &--item {
          display: flex;
          align-items: center;
          &:not(:last-child) {
            margin-bottom: 20px;
          }
          .avatar-employee {
            width: 80px;
            height: 80px;
            // border-radius: 50%;
            margin-right: 20px;
          }
        }
      }
    }
  }
}
@media (max-width: 1540px) {
  .monthly-revenue {
    .detail {
      .other-plan {
        .plan-text {
          font-size: 14px !important;
        }
        .value {
          font-size: 16px !important;
        }
      }
      .turnover__div {
        .turnover-title {
          font-size: 13px !important;
        }
        .value {
          font-size: 13px !important;
        }
      }
    }
  }
}
@media (max-width: 1599px) {
  .chart-wrapper {
    &-child {
      display: flex;
      flex-direction: column;
      align-items: center;
      .icon-up-trend {
        width: 70px;
      }
    }
  }
}
@media (max-width: 1400px) {
  .chart-wrapper {
    &-child {
      .data-up-trend {
        font-size: 12px;
      }
      .icon-up-trend {
        width: 60px;
      }
    }
  }
}
</style>
